import { faqData } from '@/mocks/home';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">常见问题</h2>
          <p className="text-foreground-600">关于七七影院的常见疑问解答</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqData.map((item, idx) => (
            <details key={idx} className="group bg-background-100 rounded-xl border border-background-200/60 overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm font-semibold text-foreground-950 pr-4">{item.q}</h3>
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 flex-shrink-0 group-open:rotate-45 transition-transform duration-200">
                  <i className="ri-add-line text-sm"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}